import React, { MouseEvent, useEffect, useState } from "react";

import { SweetOrHotLadiesDTO } from "../models";

type LocalLadyDto = SweetOrHotLadiesDTO["requestDTO"]["dataMap"]["result"];

type HookParams = {
  data: LocalLadyDto | undefined;
  fetchNextPage: () => void;
  isFetching: boolean;
  currentIndex: number;
  setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
};

export const useCurrentSweetOrHotLady = ({
  data,
  fetchNextPage,
  currentIndex,
  setCurrentIndex,
}: HookParams) => {
  const [currentLady, setCurrentLady] = useState<LocalLadyDto[number] | null>(
    null,
  );

  const nextLady = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setCurrentIndex((index) => index + 1);
  };

  useEffect(() => {
    if (!data || !data.length) return;

    if (currentIndex > data.length - 1) {
      setCurrentIndex(0);
      fetchNextPage();
      setCurrentLady(null);
      return;
    }

    setCurrentLady(data?.[currentIndex] || null);
  }, [currentIndex, currentLady, data, fetchNextPage, setCurrentIndex]);

  if (!data) return { currendLady: null, nextLady };

  return { currentLady: currentLady || null, nextLady };
};
